import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ModalOrderDetailPageRoutingModule } from './modal-order-detail-routing.module';

import { ModalOrderDetailPage } from './modal-order-detail.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModalOrderDetailPageRoutingModule
  ],
  declarations: [ModalOrderDetailPage]
})
export class ModalOrderDetailPageModule {}
